<template>
  <v-dialog persistent width="440" v-model="dialog">
    <v-card rounded="0">
      <v-toolbar color="secondary" class="white--text" dense>
        <v-toolbar-title class="font-weight-bold text-subtitle-1">
          <v-icon left class="white--text">mdi-map-marker-radius</v-icon>
          Edit Coordinates
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="white--text" @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-4 pb-0">
        <div class="caption text--secondary mb-4">
          <strong>{{ row.farmName || '—' }}</strong>
          <span v-if="row.country"> · {{ row.country }}</span>
          <span class="ml-2 grey--text">Row #{{ row.rowIndex }}</span>
        </div>

        <v-row dense>
          <v-col cols="6">
            <v-text-field
              v-model.number="editLat"
              label="Latitude"
              outlined
              dense
              type="number"
              step="0.000001"
              :error-messages="latError"
              @input="latError = ''"
              hint="-90 to 90"
              persistent-hint
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="editLng"
              label="Longitude"
              outlined
              dense
              type="number"
              step="0.000001"
              :error-messages="lngError"
              @input="lngError = ''"
              hint="-180 to 180"
              persistent-hint
            />
          </v-col>
        </v-row>

        <v-alert
          v-if="activeIssues.length"
          type="info"
          dense
          text
          class="caption mt-2 mb-0"
          icon="mdi-information-outline"
        >
          Saving clears:
          <strong v-for="(issue, i) in activeIssues" :key="issue">
            {{ issue }}<span v-if="i < activeIssues.length - 1">, </span>
          </strong>.
          DB duplicate check re-runs on import.
        </v-alert>
      </v-card-text>

      <v-card-actions class="px-4 pb-4 pt-3">
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">Cancel</v-btn>
        <v-btn color="secondary" elevation="0" @click="save">
          <v-icon left small>mdi-check</v-icon>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FarmCoordinateEditDialog',

  props: {
    value: { type: Boolean, required: true },
    row: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      editLat: null,
      editLng: null,
      latError: '',
      lngError: '',
    };
  },

  computed: {
    dialog: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); },
    },
    activeIssues() {
      const issues = this.row.issues || {};
      const list = [];
      if (issues.outsideBoundary) list.push('Outside Boundary');
      if (issues.duplicateInDb) list.push('DB Duplicate');
      if (issues.duplicateInFile) list.push('File Duplicate');
      return list;
    },
  },

  watch: {
    value(open) {
      if (open) {
        this.editLat = this.row.lat;
        this.editLng = this.row.log;
        this.latError = '';
        this.lngError = '';
      }
    },
  },

  methods: {
    cancel() {
      this.$emit('input', false);
    },

    save() {
      let valid = true;
      const lat = this.editLat;
      const lng = this.editLng;

      if (lat === null || lat === '' || isNaN(Number(lat)) || Number(lat) < -90 || Number(lat) > 90) {
        this.latError = 'Must be between -90 and 90';
        valid = false;
      }
      if (lng === null || lng === '' || isNaN(Number(lng)) || Number(lng) < -180 || Number(lng) > 180) {
        this.lngError = 'Must be between -180 and 180';
        valid = false;
      }
      if (!valid) return;

      this.$emit('saved', {
        rowIndex: this.row.rowIndex,
        lat: Number(lat),
        lng: Number(lng),
      });
      this.$emit('input', false);
    },
  },
};
</script>
